<template>
  <div>
    <h3 class="mb-6">{{ body.제목 }}</h3>
    <div class="px-4 overflow-y-auto">
      <div v-for="(문제, index) in questions" :key="`문제_${index}`">
        <p style="font-size: 1.2rem; font-weight: 500; word-break: break-all; white-space: normal;" v-html="`Q${index + 1}. ${문제.title}`"></p>
        <div class="p-2">
          <!-- 정답이 한 개인 경우 radio group -->
          <radio-group v-if="isRadioQuestion(문제)" class="mb-2" style="padding: 0.8rem 0 !important; grid-template-columns: 1fr !important; gap: 1rem !important;" v-model="submit[index]" :items="문제.options.map((item, itemIndex) => { return {label: item.label, value: itemIndex+1} })" />

          <!-- 정답이 두 개이상인 경우 checkbox-->
          <div v-else>
            <div v-for="(항목, 항목Index) in 문제.options" :key="`항목_${항목Index}`" class="mb-2">
              <vs-checkbox v-model="submit[index]" :vs-value="항목Index+1" >{{항목.label}}</vs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 flex justify-center gap-2">
      <vs-button color="#AEB1B6" @click="$emit('close')">닫기</vs-button>
      <vs-button color="#7367F0" @click="getResult(sortInnerArrays(submit))">제출</vs-button>
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: 'Questions',
  components: { RadioGroup },
  props: {
    data: Object,
  },
  computed: {
    body () {
      if (this.data) {
        return this.data.body || {};
      }
      return {};
    },
    정답 () {
      const 정답 = [];
      if (this.data) {
        this.questions.map((문제, index) => {
          const check = [];
          문제.options.map((항목, index) => {
            if (항목.answer === true) {
              check.push(index + 1);
            }
          });
          if (check.length > 1) {
            정답.push(check);
          } else {
            정답.push(check[0]);
          }
        });
      }
      return 정답;
    }
  },
  watch: {
    data(data) {
      if (data) {
        this.setSubmit();
      }
    }
  },
  data() {
    return {
      submit: [],
      questions: [],
    };
  },
  methods: {
    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "알림",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    load() {
      if (this.data) {
        // 랜덤으로 문제 출제
        const defaultQuestionsCount = 5;
        this.questions = this.body.questions.sort((a, b) => Math.random() - 0.5).slice(0, this.body.randomQuestionCount || defaultQuestionsCount);
        this.setSubmit();
      }
    },
    setSubmit() {
      if (this.submit.length === 0 && this.questions && this.questions.length > 0) {
        this.submit = Array(this.questions.length).fill(null);

        // 중복선택가능한 문제일 경우, submit 배열을 초기화
        for (let i = 0; i < this.questions.length; i++) {
          const 문제 = this.questions[i];
          if (!this.isRadioQuestion(문제)) {
            this.submit[i] = [];
          }
        }
      }
    },
    reset() {
      this.submit = [];
    },
    isRadioQuestion(문제) {
      let count = 0;
      for (const 항목 of 문제.options) {
        if (항목.answer === true) {
          count++;
        }
      }
      return count === 1;
    },
    sortInnerArrays(arr) {
      return arr.map(item => {
        // 배열인 경우 정렬
        if (Array.isArray(item)) {
          return [...item].sort((a, b) => a - b);
        }
        return item; // 배열이 아니면 그대로 반환
      });
    },

    async getResult(submit) {
      if (parseInt(this.data.author.id) !== parseInt(this.$store.state.auth.userInfo.id)) {
        this.customAlert("수강한 본인만 시험응시를 할 수 있습니다.");
        return;
      }
      let 교육이수일 = new Date().format("yyyy-MM-dd");
      let 교육만료일 = new Date(교육이수일).addDays(365).format("yyyy-MM-dd");

      let success = 0;
      let fail = 0;
      for (const [문제Index, 문제] of this.questions.entries()) {
        const 정답 = this.정답[문제Index];
        const 응답 = submit[문제Index];
        // 정답이 배열인 경우
        if (Array.isArray(정답)) {
          if (Array.isArray(응답) && JSON.stringify(정답.sort()) === JSON.stringify(응답.sort())) {
            success++;
          } else {
            fail++;
          }
        } else {
          // 정답이 단일 값인 경우
          if (정답 === 응답) {
            success++;
          } else {
            fail++;
          }
        }
      }
      const passed = success >= this.body.passCount;
      if (!passed) {
        교육이수일 = null;
        교육만료일 = null;
      }

      // 작성한 답안과 정답을 비교하여 결과를 update 후 반환
      const postId = this.data.id;
      const form = JSON.parse(this.data.post_content);
      form.body.시험결과 = passed ? "합격" : "불합격";
      form.body.submit = submit;
      form.body.교육이수일 = 교육이수일;
      form.body.교육만료일 = 교육만료일;
      form.body.questions = this.questions;
      const result = await this.$store
        .dispatch("board/UPDATE_POST", {
          projectId: this.projectId,
          boardId: 1065,
          postId,
          title: `수강내역_${this.data.id}_${this.body.제목}`,
          content: JSON.stringify(form),
        })
        .catch((error) => {
          this.customAlert(error.response.data);
          return false;
        });
      if (result) {
        const args= {
          passed,
          success,
          fail,
        }
        if (교육이수일) {
          args.교육이수일 = 교육이수일;
          args.교육만료일 = 교육만료일;
        }
        this.$emit('result', args, this.questions, submit)
      }
    }
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">

</style>
